import React from "react";
import UserDropdown from "./UserDropdown";
import "./Topbar.css";

export enum AppMode {
  TREATMENT_GOALS = "goals",
  TREATMENT_PLAN = "treatment_plan",
  DECISION_SUPPORT = "decision_support",
  PARENT_TRAINING = "parent_training",
}

interface TopbarProps {
  activeMode: AppMode;
  onModeChange: (mode: AppMode) => void;
  currentUser?: any;
  onLogout?: () => void;
}

const Topbar: React.FC<TopbarProps> = ({
  activeMode,
  onModeChange,
  currentUser,
  onLogout,
}) => {
  // Check if user is superuser to show all modes
  const isSuperuser = currentUser?.is_superuser || false;

  return (
    <div className="topbar">
      <div className="topbar__logo">
        <img src="/anna-logo.png" alt="ANNA" className="topbar__logo-img" />
        <h1 className="topbar__title">ANNA AI Studio</h1>
      </div>

      {/* Show mode buttons only for superusers, or hide if normal user has only one option */}
      {isSuperuser && (
        <div className="topbar__modes">
          <button
            className={`topbar__mode-btn ${
              activeMode === AppMode.TREATMENT_GOALS ? "active" : ""
            }`}
            onClick={() => onModeChange(AppMode.TREATMENT_GOALS)}
            data-tooltip="Treatment Goals"
          >
            <span className="mode-icon">🎯</span>
            <span className="mode-text">Treatment Goals</span>
          </button>
          <button
            className={`topbar__mode-btn ${
              activeMode === AppMode.TREATMENT_PLAN ? "active" : ""
            }`}
            onClick={() => onModeChange(AppMode.TREATMENT_PLAN)}
            data-tooltip="Treatment Plan"
          >
            <span className="mode-icon">📋</span>
            <span className="mode-text">Treatment Plan</span>
          </button>
          <button
            className={`topbar__mode-btn ${
              activeMode === AppMode.DECISION_SUPPORT ? "active" : ""
            }`}
            onClick={() => onModeChange(AppMode.DECISION_SUPPORT)}
            data-tooltip="Decision Support"
          >
            <span className="mode-icon">🧠</span>
            <span className="mode-text">Decision Support</span>
          </button>
          <button
            className={`topbar__mode-btn ${
              activeMode === AppMode.PARENT_TRAINING ? "active" : ""
            }`}
            onClick={() => onModeChange(AppMode.PARENT_TRAINING)}
            data-tooltip="Parent Training"
          >
            <span className="mode-icon">🌸</span>
            <span className="mode-text">Parent Training</span>
          </button>
        </div>
      )}

      {currentUser && onLogout && (
        <div className="topbar__user">
          <UserDropdown currentUser={currentUser} onLogout={onLogout} />
        </div>
      )}
    </div>
  );
};

export default Topbar;
